"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useQueueStaticElement;

var _useContext = _interopRequireDefault(require("./private/useContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Queues a static element to the live region.
 *
 * After the element is queued, screen reader will eventually narrate it and it cannot be changed.
 */
function useQueueStaticElement() {
  return (0, _useContext.default)().queueStaticElement;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VRdWV1ZVN0YXRpY0VsZW1lbnQiLCJ1c2VMaXZlUmVnaW9uQ29udGV4dCIsInF1ZXVlU3RhdGljRWxlbWVudCJdLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3Byb3ZpZGVycy9MaXZlUmVnaW9uVHdpbi91c2VRdWV1ZVN0YXRpY0VsZW1lbnQudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHVzZUxpdmVSZWdpb25Db250ZXh0IGZyb20gJy4vcHJpdmF0ZS91c2VDb250ZXh0JztcblxuaW1wb3J0IHR5cGUgeyBTdGF0aWNFbGVtZW50IH0gZnJvbSAnLi9wcml2YXRlL3R5cGVzJztcblxuLyoqXG4gKiBRdWV1ZXMgYSBzdGF0aWMgZWxlbWVudCB0byB0aGUgbGl2ZSByZWdpb24uXG4gKlxuICogQWZ0ZXIgdGhlIGVsZW1lbnQgaXMgcXVldWVkLCBzY3JlZW4gcmVhZGVyIHdpbGwgZXZlbnR1YWxseSBuYXJyYXRlIGl0IGFuZCBpdCBjYW5ub3QgYmUgY2hhbmdlZC5cbiAqL1xuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gdXNlUXVldWVTdGF0aWNFbGVtZW50KCk6IChlbGVtZW50OiBTdGF0aWNFbGVtZW50KSA9PiB2b2lkIHtcbiAgcmV0dXJuIHVzZUxpdmVSZWdpb25Db250ZXh0KCkucXVldWVTdGF0aWNFbGVtZW50O1xufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7QUFJQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ2UsU0FBU0EscUJBQVQsR0FBbUU7RUFDaEYsT0FBTyxJQUFBQyxtQkFBQSxJQUF1QkMsa0JBQTlCO0FBQ0QifQ==